module.exports = __webpack_public_path__ + "img/1f354.b228ba5.svg";